import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { Col, Row, Card, Spinner, Alert } from 'reactstrap';
import LoaderButton from '../loader-button/LoaderButton';
import ServiceWidget from './ServiceWidget';
import Select from 'react-select';
import { includes, isEmpty } from 'lodash';

import { VendorsContext } from '../../context/VendorsContext';
import { DashboardContext } from '../../context/DashboardContext';
import SETTINGS from '../../constants/settings';
import BZAPIService from '../../services/BZAPIService';
import ODDAPIService from '../../services/ODDAPIService';
import Heading from '../common/Heading';
import Loader from '../common/Loader';
import Background from '../common/Background';
import { toast } from 'react-toastify';
import SnIntegration from './SnIntegration';
import IntegrationStatus from './IntegrationStatus';
const Dashboard = () => {
  const bugOptions = useMemo(
    () => [
      { value: 'newBugsLastWeek', label: 'New Bugs: Last 7 Days' },
      { value: 'updatedBugsLastWeek', label: 'Updated Bugs: Last 7 Days' },
      { value: 'newBugsLastMonth', label: 'New Bugs: Last 30 Days' },
      { value: 'updatedBugsLastMonth', label: 'Updated Bugs: Last 30 Days' },
      { value: 'newBugsLastQuarter', label: 'New Bugs: Last 90 Days' },
      { value: 'updatedBugsLastQuarter', label: 'Updated Bugs: Last 90 Days' }
    ],
    []
  );

  const bugAPIOptions = useMemo(
    () => [
      { value: 'newAPIBugsLast7Days', label: 'New Bugs: Last 7 Days' },
      { value: 'updatedAPIBugsLast7Days', label: 'Updated Bugs: Last 7 Days' },
      { value: 'newAPIBugsLast30Days', label: 'New Bugs: Last 30 Days' },
      { value: 'updatedAPIBugsLast30Days', label: 'Updated Bugs: Last 30 Days' },
      { value: 'newAPIBugsLast90Days', label: 'New Bugs: Last 90 Days' },
      { value: 'updatedAPIBugsLast90Days', label: 'Updated Bugs: Last 90 Days' }
    ],
    []
  );

  const selectStyles = useMemo(
    () => ({
      option: (styles, { isDisabled, isFocused, isSelected }) => ({
        ...styles,
        color: isFocused ? 'white' : isSelected ? 'white' : 'black'
      })
    }),
    []
  );

  const bugStatus = useMemo(
    () => [{ value: 'priority', label: 'Show by Priority' }, { value: 'status', label: 'Show by Status' }],
    []
  );
  // State
  const [services, setServices] = useState([]);
  // eslint-disable-next-line
  const [vendors, setVendors] = useContext(VendorsContext);
  // eslint-disable-next-line
  const [dashboard, setDashboard] = useContext(DashboardContext);

  const [apiVendors, setAPIVendors] = useState([]);
  const [bugs, setBugs] = useState({});
  const [apiBugs, setAPIBugs] = useState({});
  const [priorityStats, setPriorityStats] = useState({});
  const [apiStats, setAPIStats] = useState({});
  const [mainLoader, setMainLoader] = useState(true);
  const [loadingServices, setLoadingServices] = useState(true);
  const [loadingODD, setLoadingODD] = useState(true);
  const [loadingSN, setLoadingSN] = useState(true);
  const [loadingAi, setLoadingAi] = useState(true);
  const [openAiTest, setOpenAiTest] = useState(false);
  const [selectedBugOption, setSelectedBugOption] = useState(bugOptions[0]);
  const [selectedAPIBugOption, setSelectedAPIBugOption] = useState(bugOptions[0]);
  // eslint-disable-next-line
  const [selectedBugStatus, setSelectedBugStatus] = useState(bugStatus[0]);
  const [selectedAPIBugStatus, setSelectedAPIBugStatus] = useState(bugStatus[0]);
  // eslint-disable-next-line
  const [snIntegrationCheck, setSnIntegrationCheck] = useState(false);
  const [snIntegrationTest, setSnIntegrationTest] = useState({});
  const [bzStatus, setBzStatus] = useState({});
  const [showBzStatus, setShowBzStatus] = useState(false);

  // Vendor Cards Filtering
  const [isShowOperational, setIsShowOperational] = useState(true);
  const [isShowError, setIsShowError] = useState(true);
  const [isShowNotConfigured, setIsShowNotConfigured] = useState(true);

  // Dashboard sections to be displayed
  const [dashboardSections, setDashboardSections] = useState([]);
  const colors = useMemo(
    () => [
      '#ff475f',
      '#000000',
      '#961ca2',
      '#35bc8e',
      '#90919a',
      '#c1bdb7',
      '#B54E34',
      '#253544',
      '#48384B',
      '#816577',
      '#445A57',
      '#617E71',
      '#829A92',
      '#567387',
      '#8096A8',
      '#b8ca26',
      '#81ce70',
      '#ae9336',
      '#c7760d',
      '#412c0e',
      '#ffdc35',
      '#80f9ad',
      '#219bb1',
      '#32424c',
      '#816477'
    ],
    []
  );
  // Memoized dashboard and vendors
  const prevVendorsRef = useRef();

  function buildVendorStat(dataSet, colors) {
    const vendorPriorityStats = {};
    vendors?.map(vendor => {
      return (vendorPriorityStats[vendor.id] = []);
    });

    dataSet?.map((bugPriority, id) => {
      // console.log('bugPriority', bugPriority);
      if (!vendorPriorityStats[bugPriority.vendorId]) vendorPriorityStats[bugPriority.vendorId] = [];
      const colorIndex = vendorPriorityStats[bugPriority.vendorId].length;

      const vendorPriorityStat = {
        id,
        value: bugPriority.priorityCount,
        name: bugPriority.priority,
        color: bugPriority.priority === 'Unspecified' ? '#90919a' : colors[colorIndex],
        filter: bugPriority.filter
      };
      vendorPriorityStats[bugPriority.vendorId].push(vendorPriorityStat);
    });

    // If no data, add 0 data for graph
    Object.keys(vendorPriorityStats).map((key, index) => {
      if (!vendorPriorityStats[key].length) {
        const vendorPriorityStat = {
          id: `z${index}`,
          value: 0.01, // Avoid NaN on graph and don't divide by 0
          name: 'No Bugs',
          color: '#d8d4ce'
        };
        vendorPriorityStats[key].push(vendorPriorityStat);
      }
    });
    return vendorPriorityStats;
  }

  function buildAPIStat(dataSet, colors) {
    const vendorAPIStats = {};
    vendors.map(vendor => {
      vendorAPIStats[vendor.id] = [];
    });

    dataSet.map((bugPriority, id) => {
      if (!vendorAPIStats[bugPriority.vendorId]) vendorAPIStats[bugPriority.vendorId] = [];
      const colorIndex = vendorAPIStats[bugPriority.vendorId].length;

      const vendorAPIStat = {
        id,
        value: bugPriority.count,
        name: bugPriority.value,
        color: bugPriority.priority === 'Unspecified' ? '#90919a' : colors[colorIndex],
        filter: bugPriority.filter
      };
      vendorAPIStats[bugPriority.vendorId].push(vendorAPIStat);
    });

    // If no data, add 0 data for graph
    Object.keys(vendorAPIStats).map((key, index) => {
      if (!vendorAPIStats[key].length) {
        const vendorAPIStat = {
          id: `z${index}`,
          value: 0.01, // Avoid NaN on graph and don't divide by 0
          name: 'No Bugs',
          color: '#d8d4ce'
        };
        vendorAPIStats[key].push(vendorAPIStat);
      }
    });
    return vendorAPIStats;
  }

  async function onLoad(sections) {
    // Display active sections with loaders within components-elements.
    setServices(dashboard?.services);
    // Dashboard and Vendor Calls
    if (sections[0]?.active || sections[1]?.active || sections[2]?.active) {
      try {
        const snIntegrationCheckPromise = BZAPIService.getSetting(SETTINGS.SERVICE_NOW);
        const snIntegrationTestPromise = BZAPIService.sNConectionTest();
        const openAiTestPromise = BZAPIService.openAiTest();
        const [snIntegrationCheck, snIntegrationTest, openAiTest] = await Promise.all([
          snIntegrationCheckPromise,
          snIntegrationTestPromise,
          openAiTestPromise
        ]);

        // Check ServiceNow is configured
        isEmpty(snIntegrationCheck)
          ? setSnIntegrationCheck(false)
          : !snIntegrationTest.valid
          ? setSnIntegrationCheck(false)
          : setSnIntegrationCheck(true);

        setSnIntegrationTest(snIntegrationTest);
        setLoadingSN(false);

        // Check Open Ai service is working
        isEmpty(openAiTest) || openAiTest?.service_issues ? setOpenAiTest(false) : setOpenAiTest(true);

        setLoadingAi(false);

        // setLoadingServices(false);

        // Setup vendor priority stats
        const newBugsLastWeek = buildVendorStat(dashboard?.newBugsLastWeek, colors);
        const updatedBugsLastWeek = buildVendorStat(dashboard?.updatedBugsLastWeek, colors);
        const newBugsLastMonth = buildVendorStat(dashboard?.newBugsLastMonth, colors);
        const updatedBugsLastMonth = buildVendorStat(dashboard?.updatedBugsLastMonth, colors);
        const newBugsLastQuarter = buildVendorStat(dashboard?.newBugsLastQuarter, colors);
        const updatedBugsLastQuarter = buildVendorStat(dashboard?.updatedBugsLastQuarter, colors);
        console.log('newBugsLastWeek', newBugsLastWeek);
        const bugs = {
          newBugsLastWeek,
          updatedBugsLastWeek,
          newBugsLastMonth,
          updatedBugsLastMonth,
          newBugsLastQuarter,
          updatedBugsLastQuarter
        };
        setPriorityStats(newBugsLastWeek);
        setBugs(bugs);

        setLoadingServices(false);
        // Validate config
      } catch (e) {
        console.log(e);
        setLoadingSN(false);
        setLoadingAi(false);
      }
      try {
        // Check our own BE status hosted in AWS
        const res = await fetch('https://sls-eus-dev-ec37c2-apim.azure-api.net/getHealth?region=us-east-1');
        const status = await res.json();

        setBzStatus(status);
        if (status?.issuesFound) setShowBzStatus(true);
        // console.log(bzStatus);
      } catch (e) {
        console.log('could not get BZ status');
      }
    }
    // BugZero API
    if (sections[3]?.active) {
      try {
        const oddSettingsPromise = ODDAPIService.getSettings();
        const bugCountPromise = ODDAPIService.getBugCounts();
        const [oddSettings, bugCount] = await Promise.all([oddSettingsPromise, bugCountPromise]);

        setLoadingServices(false);

        setAPIVendors(oddSettings?.filter(v => v.vendorId !== 'restapi')?.map(v => v.vendorId));
        // API Stats
        const newAPIBugsLast7Days = buildAPIStat(bugCount.newBugsLast7Days, colors);
        const updatedAPIBugsLast7Days = buildAPIStat(bugCount.updatedBugsLast7Days, colors);
        const newAPIBugsLast30Days = buildAPIStat(bugCount.newBugsLast30Days, colors);
        const updatedAPIBugsLast30Days = buildAPIStat(bugCount.updatedBugsLast30Days, colors);
        const newAPIBugsLast90Days = buildAPIStat(bugCount.newBugsLast90Days, colors);
        const updatedAPIBugsLast90Days = buildAPIStat(bugCount.updatedBugsLast90Days, colors);

        const apiBugs = {
          newAPIBugsLast7Days,
          updatedAPIBugsLast7Days,
          newAPIBugsLast30Days,
          updatedAPIBugsLast30Days,
          newAPIBugsLast90Days,
          updatedAPIBugsLast90Days
        };
        setAPIStats(newAPIBugsLast7Days);
        setAPIBugs(apiBugs);
        setLoadingODD(false);
        setLoadingServices(false);
      } catch (e) {
        console.log(e);
        setLoadingODD(false);
      }
    }
  }

  async function getSections() {
    // First check which dashboard sections are active, if not, set defaults
    try {
      const sections = [
        { label: 'Integrations', value: 'displayIntegration', active: 1 },
        { label: 'Vendor Integrations', value: 'displayVendorIntegration', active: 1 },
        { label: 'Tenant Bug Stats', value: 'displayTenantBugStats', active: 1 },
        { label: 'ODD Bug stats', value: 'displayOddBugStats', active: 1 }
      ];
      const dash = await BZAPIService.getBzDashboard();
      setDashboardSections(isEmpty(dash) || dash?.data === null ? sections : dash?.data?.bugZeroDashboard?.display);
      setMainLoader(false);
      // console.log('services return?', dash?.data?.bugZeroDashboard?.display);
      return isEmpty(dash) || dash?.data === null ? sections : dash?.data?.bugZeroDashboard?.display;
    } catch (e) {
      console.log(e);
      setMainLoader(false);
    }
  }

  useEffect(() => {
    if (vendors?.length && dashboard?.services?.length && !prevVendorsRef?.current?.length) {
      getSections()
        .then(sections => onLoad(sections))
        .catch(e => console.error(e));
    }

    // Update the refs to the current state to prevent dupelicate load
    prevVendorsRef.current = vendors;
  }, [vendors, dashboard]);

  async function handleChange(e) {
    if (e?.value === 'status' || e?.value === 'priority') {
      setSelectedBugStatus(e);
    } else {
      setSelectedBugOption(e);
      setPriorityStats(bugs[e.value]);
    }
  }

  async function handleAPIChange(e) {
    if (e?.value === 'status' || e?.value === 'priority') {
      setSelectedAPIBugStatus(e);
    } else {
      setAPIStats(apiBugs[e.value]);
      setSelectedAPIBugOption(e);
    }
  }

  const updateServices = async () => {
    try {
      setLoadingServices(true);
      const dataPromise = BZAPIService.getDashboard();
      const bugCountPromise = ODDAPIService.getBugCounts();
      const oddSettingsPromise = ODDAPIService.getSettings();

      const [data, bugCount, oddSettings] = await Promise.all([dataPromise, bugCountPromise, oddSettingsPromise]);

      const { services } = data;
      setServices(services);
      setAPIVendors(oddSettings.map(v => v.vendorId));
      // Setup vendor priority stats

      const newBugsLastWeek = buildVendorStat(data?.newBugsLastWeek, colors);
      const updatedBugsLastWeek = buildVendorStat(data?.updatedBugsLastWeek, colors);
      const newBugsLastMonth = buildVendorStat(data?.newBugsLastMonth, colors);
      const updatedBugsLastMonth = buildVendorStat(data?.updatedBugsLastMonth, colors);
      const newBugsLastQuarter = buildVendorStat(data?.newBugsLastQuarter, colors);
      const updatedBugsLastQuarter = buildVendorStat(data?.updatedBugsLastQuarter, colors);
      const bugs = {
        newBugsLastWeek,
        updatedBugsLastWeek,
        newBugsLastMonth,
        updatedBugsLastMonth,
        newBugsLastQuarter,
        updatedBugsLastQuarter
      };
      setPriorityStats(newBugsLastWeek);
      setBugs(bugs);

      // API Stats
      const newAPIBugsLast7Days = buildAPIStat(bugCount.newBugsLast7Days, colors);
      const updatedAPIBugsLast7Days = buildAPIStat(bugCount.updatedBugsLast7Days, colors);
      const newAPIBugsLast30Days = buildAPIStat(bugCount.newBugsLast30Days, colors);
      const updatedAPIBugsLast30Days = buildAPIStat(bugCount.updatedBugsLast30Days, colors);
      const newAPIBugsLast90Days = buildAPIStat(bugCount.newBugsLast90Days, colors);
      const updatedAPIBugsLast90Days = buildAPIStat(bugCount.updatedBugsLast90Days, colors);

      const apiBugs = {
        newAPIBugsLast7Days,
        updatedAPIBugsLast7Days,
        newAPIBugsLast30Days,
        updatedAPIBugsLast30Days,
        newAPIBugsLast90Days,
        updatedAPIBugsLast90Days
      };
      setAPIStats(newAPIBugsLast7Days);
      setAPIBugs(apiBugs);

      setLoadingServices(false);
    } catch (e) {
      console.log(e);
      setLoadingServices(false);
      toast.error('Unable to updates stats...');
    }
  };

  const handleVendorCardFiltering = (e, setHook) => {
    const id = e.currentTarget.id;
    console.log(e.currentTarget.id);
    if (id === 'operational') setHook(!isShowOperational);
    if (id === 'error') setHook(!isShowError);
    if (id === 'notconfig') setHook(!isShowNotConfigured);
  };
  return (
    <div className="min-vh-75">
      {/* Integrations section */}

      {mainLoader && <Loader />}
      {!mainLoader && bzStatus?.issuesFound ? (
        <Alert color={'danger'} isOpen={showBzStatus} toggle={() => setShowBzStatus(false)}>
          BugZero services might be suffering interruptions due to the following third party errors:
          <ul>
            {bzStatus?.currentIssues?.length &&
              bzStatus?.currentIssues?.map((i, idx) => {
                return (
                  <li key={idx + '-' + i.summary} className="my-2">
                    <strong>{i.summary}</strong>
                    {/* <ul>
                    {i.timeline?.map(t => {
                      return <li key={t[0]}>{t[1]}</li>;
                    })}
                  </ul> */}
                  </li>
                );
              })}
          </ul>
        </Alert>
      ) : (
        <></>
      )}
      {dashboardSections?.length ? (
        <>
          <Heading title="Service Status" subtitle={`Current service status`} className="mb-2 mt-3" icon="cog" />
          <Row className="g-0">
            {/* Integrations section */}
            {dashboardSections[0]?.active && !mainLoader ? (
              <>
                <SnIntegration
                  title={'ServiceNow'}
                  to={'servicenow'}
                  loading={loadingSN}
                  test={snIntegrationTest}
                  check={snIntegrationCheck}
                />
                <SnIntegration title={'OpenAI'} to={'openai'} loading={loadingAi} test={{}} check={openAiTest} />
              </>
            ) : (
              <></>
            )}
          </Row>
          {/* End of Integrations section */}

          {/* Vendor services section */}
          {dashboardSections[1]?.active && !mainLoader && (
            <>
              {/* Add filter by status checkboxes */}
              <IntegrationStatus
                loadingServices={loadingServices}
                updateServices={updateServices}
                services={services?.length ? services : dashboard?.services}
                dashboardSections={dashboardSections}
                isShowError={isShowError}
                setIsShowError={setIsShowError}
                isShowNotConfigured={isShowNotConfigured}
                setIsShowNotConfigured={setIsShowNotConfigured}
                isShowOperational={isShowOperational}
                setIsShowOperational={setIsShowOperational}
                handleVendorCardFiltering={handleVendorCardFiltering}
              />
            </>
          )}
          {/* End of Vendor services section */}
          {/* Vendor stats section */}

          {dashboardSections[2]?.active && !mainLoader && (
            <>
              <Heading
                title="Operational Bugs"
                subtitle={`Operational bug statistics`}
                className={`mb-2 ${dashboardSections[1]?.active ? 'mt-5' : 'mt-3'}`}
                icon="bug"
              />
              <Row className="g-0">
                <Col md={6} className="col-xxl-3 mb-3 pr-md-2 pl-xxl-2">
                  <Select
                    id="bug-options-select"
                    value={selectedBugOption}
                    onChange={handleChange}
                    options={bugOptions}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        // text: 'white',
                        primary25: '#253746',
                        primary: '#bd472a'
                        // neutral0: 'white',
                        // neutral80: 'white'
                      }
                    })}
                    styles={selectStyles}
                    className="shadow"
                  />
                </Col>
                <Col className="text-right">
                  <LoaderButton
                    className="btn btn-falcon-primary mr-2"
                    onClick={updateServices}
                    name="save-and-add"
                    isLoading={loadingServices}
                    data-testid={'refresh-bugs-btn'}
                  >
                    Refresh
                  </LoaderButton>
                </Col>
              </Row>
            </>
            // ) : (
            //   <></>
          )}

          {/* Tenant Bug Stats section */}
          <Row className="g-0">
            {dashboardSections[2]?.active && !mainLoader ? (
              <>
                {vendors
                  ?.filter(vendor => vendor?.active)
                  ?.filter(v => v?.type === 'vendor')
                  ?.map((vendor, key) => {
                    return (
                      <Col key={key} md={6} className="col-xxl-3 mb-3 pr-md-2 pl-xxl-2">
                        <ServiceWidget
                          data={priorityStats[(vendor?.id)]}
                          title={vendor?.name?.replace('Systems', 'Networks')}
                          // status={selectedBugStatus}
                          loading={loadingServices}
                        />
                      </Col>
                    );
                  })}
              </>
            ) : (
              <>
                <Loader />
              </>
            )}
          </Row>

          {/* End of Tenant Bug Stats section */}

          {/* BZ API stats section */}

          {dashboardSections[3]?.active && !mainLoader ? (
            <>
              <Heading
                title="BugZero API"
                subtitle={`Operational bug statistics`}
                className={`mb-2 ${dashboardSections[2]?.active ? 'mt-5' : 'mt-3'}`}
                icon="bug"
              />
              <Row className="g-0">
                <Col md={6} className="col-xxl-3 mb-3 pr-md-2 pl-xxl-2">
                  <Select
                    id="bug-options-select"
                    value={selectedAPIBugOption}
                    onChange={handleAPIChange}
                    options={bugAPIOptions}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        // text: 'white',
                        primary25: '#253746',
                        primary: '#bd472a'
                        // neutral0: 'white',
                        // neutral80: 'white'
                      }
                    })}
                    styles={selectStyles}
                    className="shadow"
                  />
                </Col>
                <Col md={6} className="col-xxl-3 mb-3 pr-md-2 pl-xxl-2">
                  <Select
                    id="bug-statuses-select"
                    value={selectedAPIBugStatus}
                    onChange={handleAPIChange}
                    options={bugStatus}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        // text: 'white',
                        primary25: '#253746',
                        primary: '#bd472a'
                        // neutral0: 'white',
                        // neutral80: 'white'
                      }
                    })}
                    className="shadow"
                    styles={selectStyles}
                  />
                </Col>
                <Col className="text-right">
                  <LoaderButton
                    className="btn btn-falcon-primary mr-2"
                    onClick={updateServices}
                    name="save-and-add"
                    isLoading={loadingServices}
                    data-testid={'refresh-bugs-btn'}
                  >
                    Refresh
                  </LoaderButton>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
          <Row className="g-0">
            {dashboardSections[3]?.active && !mainLoader && loadingODD ? (
              [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(i => {
                return (
                  <Col xs={6} key={i + '-odd-card-placeholder'} className="col-xxl-4 mb-1 pr-md-2 pl-xxl-2">
                    <Card className="mb-3 overflow-hidden" style={{ minWidth: '24rem', minHeight: '8rem' }}>
                      <Background className={`bg-card`} />
                      <Spinner size={'sm'} color="primary" className="my-auto mx-auto" />
                    </Card>
                  </Col>
                );
              })
            ) : dashboardSections[3]?.active && !loadingODD && apiVendors?.length ? (
              apiVendors?.map((vendor, key) => {
                return (
                  <Col key={key} md={6} className="col-xxl-3 mb-3 pr-md-2 pl-xxl-2">
                    <ServiceWidget
                      data={!isEmpty(apiStats) && includes(Object.keys(apiStats), vendor) ? apiStats[vendor] : []}
                      title={vendor?.replace('Systems', 'Networks')}
                      status={selectedAPIBugStatus}
                    />
                    {/* {console.log('stats', apiStats)} */}
                  </Col>
                );
              })
            ) : (
              <></>
            )}
          </Row>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Dashboard;
